import { useFiltersLayout } from '../FiltersLayoutContext'
import { TPageFilter } from '../types'
import { PinnedFilterContent } from './PinnedFilterContent'
import { useGetPageFilters } from './useGetPageFilters'
import { useSubmitPageFilters } from './useSubmitPageFilters'
import { useGetAppPage } from '../useGetAppPage'

type FilterContentProps = {
  pinnedFilters: TPageFilter[]
  actionsRef: React.RefObject<HTMLDivElement>
}

export function HeaderFilterContent({ pinnedFilters, actionsRef }: FilterContentProps) {
  const {
    data: { autoSubmitPinnedFilters },
  } = useGetAppPage()
  const { data } = useGetPageFilters()
  const { unpinFilter } = useFiltersLayout()
  const { submitFilters, defaultsFromPersisted, isMounted } = useSubmitPageFilters()

  // Make sure we have data and the component is mounted
  if (!data || !isMounted) {
    return null
  }

  return (
    <PinnedFilterContent
      schema={data.data}
      submitHandler={submitFilters}
      pinnedFilters={pinnedFilters}
      unPinFilter={unpinFilter}
      resetDefaults={defaultsFromPersisted}
      actionsRef={actionsRef}
      autoSubmitPinnedFilters={autoSubmitPinnedFilters ?? false}
    />
  )
}
